export const MIRROR_VIDEO_LABEL = "Mirror my video";

export const CAMERA_NOT_ENABLED_HELP_TEXT =
  "Your camera is not enabled. Allow access to your camera from your Site Settings.";

export const CAMERA_OFF_HELP_TEXT =
  "Your camera is turned off. Selecting a background will turn your camera on.";

export const STORED_ACCESSIBILITY_SETTINGS_KEY =
  "accessibility-settings-104abc59-c1e1-4a72-a3e3-0afe7e3ed141";
